const ShimmerEffect = () => (
    <div className="animate-pulse flex flex-col gap-8 w-full">
        <div className=' flex flex-row animate-pulse gap-4 mt-3 w-full'>
            <div className="h-14 bg-gray-200 rounded-sm mb-4 w-1/3"></div>
            <div className="h-14 bg-gray-200 rounded-sm mb-4 w-1/3"></div>
            <div className="h-14 bg-gray-200 rounded-sm mb-4 w-1/3"></div>
        </div>
        <div className=' flex flex-row animate-pulse gap-4 mt-3 w-full'>
            <div className="h-14 bg-gray-200 rounded-sm mb-4 w-1/3"></div>
            <div className="h-14 bg-gray-200 rounded-sm mb-4 w-1/3"></div>
            <div className="h-14 bg-gray-200 rounded-sm mb-4 w-1/3"></div>
        </div>
        <div className=' flex flex-row animate-pulse gap-4 mt-3 w-full'>
            <div className="h-14 bg-gray-200 rounded-sm mb-4 w-1/3"></div>
            <div className="h-14 bg-gray-200 rounded-sm mb-4 w-1/3"></div>
            <div className="h-14 bg-gray-200 rounded-sm mb-4 w-1/3"></div>
        </div>
        <div className='animate-pulse mt-3 w-full'>
            <div className="h-14 bg-gray-200 rounded-sm mb-4 w-[30%]"></div>
        </div>
        <div className='animate-pulse mt-3 w-full'>
            <div className="h-14 bg-gray-200 rounded-sm mb-4 w-full"></div>
        </div>

    </div>
);

export default ShimmerEffect;